/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const UserRegister = {

	getValidateNipUniqueness (context, nip, onSuccess, onError, options) {
		Api.get(context,
			"/user-register/validate-nip-uniqueness"
			+ "?nip=" + nip
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getValidateOrganizationEmailUniqueness (context, email, onSuccess, onError, options) {
		Api.get(context,
			"/user-register/validate-organization-email-uniqueness"
			+ "?email=" + email
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getValidateOrganizationNamesUniqueness (context, polishName, englishName, onSuccess, onError, options) {
		Api.get(context,
			"/user-register/validate-organization-names-uniqueness"
			+ "?polishName=" + polishName
			+ "&englishName=" + englishName
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getValidateUserEmailUniqueness (context, email, onSuccess, onError, options) {
		Api.get(context,
			"/user-register/validate-user-email-uniqueness"
			+ "?email=" + email
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postChangeEmail (context, email, newEmail, onSuccess, onError, options) {
		Api.post(context,
			"/user-register/change-email"
			+ "?email=" + email
			+ "&newEmail=" + newEmail
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRegisterInner (context, request, onSuccess, onError, options) {
		Api.post(context,
			"/user-register/register-inner"
			, request
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRegisterSubBidder (context, request, onSuccess, onError, options) {
		Api.post(context,
			"/user-register/register-sub-bidder"
			, request
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRegisterVolunteer (context, registerVolunteerDTO, onSuccess, onError, options) {
		Api.post(context,
			"/user-register/register-volunteer"
			, registerVolunteerDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postUpdateUser (context, request, onSuccess, onError, options) {
		Api.post(context,
			"/user-register/update-user"
			, request
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
